import React, { useEffect, useState } from "react"
import TicketHelp from "./TicketHelp"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable" 
import drawer from "../../../assets/images/flags/drawer.png"
import List from "../../../assets/images/flags/bucket-list.png"
import Warning from "../../../assets/images/flags/warning.png"
import Activity from "../../../assets/images/flags/cal2.png"
import AllTickets from "./AllTickets" 
import GeneralTask from "pages/Dashboard/GeneralTask"
import "../../../assets/css/Work/support.css"

const Help = () => {
    const [ticket, setTicket] = useState(false)
    const [activity, setActivity] = useState(false)
    const [ticketList, setTicketList] = useState(false)
    const [boxWidth, setBoxWidth] = useState(0)
    const [activityBoxWidth, setActivityBoxWidth] = useState(0)
    const [boxHeight, setBoxHeight] = useState(0)
    const [ticketBoxWidth, setTicketBoxWidth] = useState(0)
    const [openOption, setOpenOption] = useState(false)
    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth
            const viewportHight = window.innerHeight
            setBoxHeight(viewportHight * 0.84)
            setBoxWidth(viewportWidth * 0.8)
            setActivityBoxWidth(viewportWidth * 0.84)
            setTicketBoxWidth(viewportWidth * 0.9)
        }
        updateWidth()
        window.addEventListener("resize", updateWidth)
        return () => window.removeEventListener("resize", updateWidth)
    }, [])
    const closeModal = modal => {
        setTicket(modal)
    }
    const closeModalList = modal => {
        setTicketList(modal)
    }
    const closeActivities = modal => {
        setActivity(modal)
    }
    return (
        <>
            <Draggable handle=".floating-button">
                <div className={`floating-container ${openOption ? "show" : ""}`}>
                    <div
                        className="floating-button"
                        onClick={() => setOpenOption(!openOption)}
                    >
                        <div className="position-absolute w-100 h-100"></div>
                        <img src={drawer} alt="Bug" width={32} height={32} />
                    </div>
                    {openOption ? (
                        <div className="element-container">

                            <a
                                className="float-element new-option"
                                onClick={() => setActivity(!activity)}
                                title="My Activites"
                            >
                                <img
                                    className="material-icons"
                                    src={Activity}
                                    alt="Bug"
                                    width={28}
                                    height={28}
                                />
                            </a>
                            <a
                                className="float-element"
                                onClick={() => setTicketList(!ticketList)}
                                title="All Reported Bugs"
                            >
                                <img
                                    className="material-icons"
                                    src={List}
                                    alt="Bug"
                                    width={28}
                                    height={28}
                                />
                            </a>
                            <a
                                className="float-element"
                                onClick={() => setTicket(!ticket)}
                                title="Bug Report"
                            >
                                <img
                                    className="smaterial-icons"
                                    src={Warning}
                                    alt="Bug"
                                    width={50}
                                    height={50}
                                />
                            </a>
                        </div>
                    ) : null}
                </div>
            </Draggable> 

            <div className={`note-sticky-form ${ticket ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={boxWidth}
                        style={{
                            position: "fixed",
                            top: "16%",
                            right: "16%",
                            zIndex: "1055",
                            backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header pe-4">
                            <h5 className="modal-title mt-0">
                                Report an Issue or Provide Feedback
                            </h5>
                            <button
                                type="button"
                                onClick={() => {
                                    setTicket(false)
                                }}
                                className="btn-modal-close"
                            >
                                <span aria-hidden="true" className="btn-modal-span">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <TicketHelp closeModal={closeModal} />
                    </ResizableBox>
                </Draggable>
            </div>
            <div className={`note-sticky-form ${ticketList ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={ticketBoxWidth}
                        style={{
                            position: "fixed",
                            top: "16%",
                            right: "5%",
                            zIndex: "1055",
                            backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header pe-4">
                            <h5 className="modal-title mt-0">
                                All Reported Bugs & Suggestions
                            </h5>
                            <button
                                type="button"
                                onClick={() => {
                                    setTicketList(false)
                                }}
                                className="btn-modal-close"
                            >
                                <span aria-hidden="true" className="btn-modal-span">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <AllTickets closeModal={closeModalList} ticketList={ticketList} />
                    </ResizableBox>
                </Draggable>
            </div>

            <div className={`note-sticky-form ${activity ? "d-block" : "d-none"}`}>
                <Draggable handle=".activity-drag-handle" cancel=".modal-body">
                  
                    <div
                        style={{
                            position: "fixed",
                            top: "10%",
                            right: "8%",
                            zIndex: "1001",
                            backgroundColor: "#fff",
                            width: activityBoxWidth,
                            height: boxHeight,
                            overflow: "hidden",
                            // transform: "translate(-50%, -50%)",
                            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                        }}
                    > 

                        {/* SCROLLABLE BODY */}
                        <div
                            className="modal-body-custom"
                            style={{
                                maxHeight: boxHeight - 60, // header height adjustment
                                overflowY: "auto",
                                overflowX: "hidden",
                                scrollbarWidth: "thin", // Firefox
                                scrollbarColor: "#c1c1c1 transparent",
                            }}
                        > 

                            <GeneralTask closeActivities={closeActivities}/>
                        </div>
                        {/* </ResizableBox> */}
                    </div>
                </Draggable>
            </div>
        </>
    )
}

export default Help
